var validateCpf = (value = '') => {
  const cpf = value.replace(/\D/g, '');

  if (cpf.length !== 11 || /^([0-9])\1+$/.test(cpf)) return false; // all repeated or short

  const first9DigitsSum = cpf
    .split('')
    .slice(0, 9)
    .reverse()
    .reduce((acc, val, i) => acc + val * (i + 2), 0);
  const firstVerificationDigit = ((first9DigitsSum * 10) % 11) % 10;

  const first10DigitsSum = cpf
    .split('')
    .slice(0, 10)
    .reverse()
    .reduce((acc, val, i) => acc + val * (i + 2), 0);
  const secondVerificationDigit = ((first10DigitsSum * 10) % 11) % 10;

  return Number(cpf[9]) === firstVerificationDigit && Number(cpf[10]) === secondVerificationDigit;
};

export { validateCpf as default };
//# sourceMappingURL=validate-cpf.js.map
